import { Card, CardBody, Col, Table } from "reactstrap";
import { TransactionHistoryTitle } from "../../../../Constants/Constants";
import { TransactionHistoryData } from "../../../../Data/General/Widgets/General";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import SvgIcon from "../../../CommonComponents/SvgIcon/SvgIcon";
import { Link } from "react-router-dom";
import { H5 } from "../../../../AbstractElements";

const TransactionHistory = () => {
  return (
    <Col xxl="4" sm="6" className="box-col-6">
      <Card className="transaction-history">
        <DashboardCommonHeader title={TransactionHistoryTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div className="table-responsive custom-scrollbar">
            <Table className="display">
              <tbody>
                {TransactionHistoryData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex">
                        <span className={`bg-light-${item.color} history`}>
                            <SvgIcon iconId={item.icon}/>
                        </span>
                        <div className="flex-grow-1 ms-2">
                          <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product-list`}>
                            <span>{item.title}</span>
                            <H5>{item.date}</H5>
                          </Link>
                        </div>
                      </div>
                    </td>
                    <td>{item.stash}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TransactionHistory;
